import { PATH_TAGS_FEATURE } from "../consts";

export type ActionTypes = {
  RECEIVE_TAGS_AND_CATEGORIES: string;
  CREATE_TAG: string;
  UPDATE_TAG: string;
  DELETE_TAG: string;
};

export function makeActionTypes(featureName: string) {
  return {
    RECEIVE_TAGS_AND_CATEGORIES: `seneca/${featureName}/RECEIVE_TAGS_AND_CATEGORIES`,
    CREATE_TAG: `seneca/${featureName}/CREATE_TAG`,
    UPDATE_TAG: `seneca/${featureName}/UPDATE_TAG`,
    DELETE_TAG: `seneca/${featureName}/DELETE_TAG`
  };
}

export default makeActionTypes(PATH_TAGS_FEATURE);
